import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

/** The parts of an embedded analysis the block shows, polled while the analysis runs. */
export const GET_EMBEDDED_ANALYSIS_QUERY = gql`
  query GetEmbeddedAnalysis($analysisId: StrictString!) @skipAudit @engComponent(name: ANALYSIS_TOOL) {
    analysis(id: $analysisId) {
      ... on AnalysisNode {
        id
        url
        ... on PipelineInterface {
          name
          steps {
            id
            stepType
            statusCode
            config
            incomingEdges {
              fromStep {
                id
              }
            }
            outputStepDatas {
              id
              rawDatas {
                ... on DataFrameDomainNode {
                  id
                  name
                }
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }

  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
